/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ActiveProfileSnapshotDto
 */
export interface ActiveProfileSnapshotDto {
    /**
     *
     * @type {string}
     * @memberof ActiveProfileSnapshotDto
     */
    uniqueId?: string;
    /**
     *
     * @type {string}
     * @memberof ActiveProfileSnapshotDto
     */
    targetDistributionBoardId?: string;
    /**
     *
     * @type {string}
     * @memberof ActiveProfileSnapshotDto
     */
    profileType?: ActiveProfileSnapshotDtoProfileTypeEnum;
    /**
     *
     * @type {number}
     * @memberof ActiveProfileSnapshotDto
     */
    limitL1Amps?: number;
    /**
     *
     * @type {number}
     * @memberof ActiveProfileSnapshotDto
     */
    limitL2Amps?: number;
    /**
     *
     * @type {number}
     * @memberof ActiveProfileSnapshotDto
     */
    limitL3Amps?: number;
    /**
     *
     * @type {Array<string>}
     * @memberof ActiveProfileSnapshotDto
     */
    activationDeviceIds?: Array<string>;
}

/**
 * @export
 */
export const ActiveProfileSnapshotDtoProfileTypeEnum = {
    Default: "Default",
    Failsafe: "Failsafe",
    TimeOfUse: "TimeOfUse",
    Trigger: "Trigger",
    Remote: "Remote",
    Unknown: "Unknown",
} as const;
export type ActiveProfileSnapshotDtoProfileTypeEnum =
    (typeof ActiveProfileSnapshotDtoProfileTypeEnum)[keyof typeof ActiveProfileSnapshotDtoProfileTypeEnum];

/**
 * Check if a given object implements the ActiveProfileSnapshotDto interface.
 */
export function instanceOfActiveProfileSnapshotDto(
    value: object,
): value is ActiveProfileSnapshotDto {
    return true;
}

export function ActiveProfileSnapshotDtoFromJSON(
    json: any,
): ActiveProfileSnapshotDto {
    return ActiveProfileSnapshotDtoFromJSONTyped(json, false);
}

export function ActiveProfileSnapshotDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ActiveProfileSnapshotDto {
    if (json == null) {
        return json;
    }
    return {
        uniqueId: json["uniqueId"] == null ? undefined : json["uniqueId"],
        targetDistributionBoardId:
            json["targetDistributionBoardId"] == null
                ? undefined
                : json["targetDistributionBoardId"],
        profileType:
            json["profileType"] == null ? undefined : json["profileType"],
        limitL1Amps:
            json["limitL1Amps"] == null ? undefined : json["limitL1Amps"],
        limitL2Amps:
            json["limitL2Amps"] == null ? undefined : json["limitL2Amps"],
        limitL3Amps:
            json["limitL3Amps"] == null ? undefined : json["limitL3Amps"],
        activationDeviceIds:
            json["activationDeviceIds"] == null
                ? undefined
                : json["activationDeviceIds"],
    };
}

export function ActiveProfileSnapshotDtoToJSON(
    value?: ActiveProfileSnapshotDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        uniqueId: value["uniqueId"],
        targetDistributionBoardId: value["targetDistributionBoardId"],
        profileType: value["profileType"],
        limitL1Amps: value["limitL1Amps"],
        limitL2Amps: value["limitL2Amps"],
        limitL3Amps: value["limitL3Amps"],
        activationDeviceIds: value["activationDeviceIds"],
    };
}
